import { translate } from "../i18n";
export const PRODUCTS = [{
  "id": "cards",
  "title": translate("Biglietti da visita"),
  "category": translate("Azienda"),
  "description": translate("Un primo contatto che resta. Scegli carta, formato e finiture adatti alla tua identit\xE0."),
  "service": translate("Stampati aziendali")
}, {
  "id": "brochures",
  "title": translate("Cataloghi e riviste"),
  "category": translate("Editoria"),
  "description": translate("Prodotti, immagini e contenuti trovano il loro spazio in una pubblicazione curata da sfogliare."),
  "service": translate("Stampati aziendali")
}, {
  "id": "stationery",
  "title": translate("Coordinati aziendali"),
  "category": translate("Azienda"),
  "description": translate("Un unico linguaggio visivo per tutti i materiali con cui presenti la tua attivit\xE0."),
  "service": translate("Stampati aziendali")
}, {
  "id": "labels",
  "title": translate("Etichette in rotolo"),
  "category": translate("Etichette"),
  "description": translate("Per confezioni e prodotti: forma, adesivo e supporto si scelgono in base all\u2019applicazione."),
  "service": translate("Adesivi & etichette")
}, {
  "id": "calendars",
  "title": translate("Calendari personalizzati"),
  "category": translate("Eventi e regali"),
  "description": translate("Da tavolo o da parete, un anno di immagini e messaggi che parlano della tua attivit\xE0."),
  "service": translate("Soluzioni per aziende")
}, {
  "id": "rollup",
  "title": translate("Roll-up ed espositori"),
  "category": translate("Grande formato"),
  "description": translate("Un punto di attenzione per fiere, incontri e negozi, pronto ad accompagnare la tua comunicazione."),
  "service": translate("Grande formato")
}, {
  "id": "notepads",
  "title": translate("Blocchi per appunti"),
  "category": translate("Azienda"),
  "description": translate("Spazio alle note, con il tuo marchio sempre presente. Formati e interni su misura."),
  "service": translate("Stampati aziendali"),
  "sheet": "office",
  "cell": 0
}, {
  "id": "envelopes",
  "title": translate("Buste personalizzate"),
  "category": translate("Azienda"),
  "description": translate("La comunicazione comincia prima di aprire la busta. Un dettaglio coordinato che si riconosce."),
  "service": translate("Stampati aziendali"),
  "sheet": "office",
  "cell": 1
}, {
  "id": "letterhead",
  "title": translate("Carta intestata"),
  "category": translate("Azienda"),
  "description": translate("Lettere e documenti con un\u2019identit\xE0 precisa, dall\u2019intestazione alla scelta della carta."),
  "service": translate("Stampati aziendali"),
  "sheet": "office",
  "cell": 2
}, {
  "id": "folders",
  "title": translate("Cartelline portadocumenti"),
  "category": translate("Azienda"),
  "description": translate("Raccogli offerte, presentazioni e materiali commerciali in una cartellina pensata per il tuo marchio."),
  "service": translate("Stampati aziendali"),
  "sheet": "office",
  "cell": 3
}, {
  "id": "binders",
  "title": translate("Raccoglitori e classificatori ad anelli"),
  "category": translate("Azienda"),
  "description": translate("Organizza documentazione, listini e progetti con copertine personalizzate facili da riconoscere."),
  "service": translate("Stampati aziendali"),
  "sheet": "office",
  "cell": 4
}, {
  "id": "duplicate",
  "title": translate("Blocchi autocopianti"),
  "category": translate("Azienda"),
  "description": translate("Ordini, rapporti e ricevute in pi\xF9 copie. Impostiamo i campi secondo il tuo lavoro."),
  "service": translate("Stampati aziendali"),
  "sheet": "office",
  "cell": 5
}, {
  "id": "rigid",
  "title": translate("Pannelli e supporti rigidi"),
  "category": translate("Grande formato"),
  "description": translate("Insegne, allestimenti e comunicazioni su pannello: il supporto giusto per ogni spazio."),
  "service": translate("Grande formato"),
  "sheet": "promo",
  "cell": 0
}, {
  "id": "vinyl",
  "title": translate("Adesivi in PVC"),
  "category": translate("Etichette"),
  "description": translate("Dal vetro alle superfici lisce, scegliamo materiale e taglio in funzione della destinazione."),
  "service": translate("Adesivi & etichette"),
  "sheet": "promo",
  "cell": 1
}, {
  "id": "banners",
  "title": translate("Banner e striscioni"),
  "category": translate("Grande formato"),
  "description": translate("Messaggi ampi e ben visibili per eventi e spazi commerciali, con finiture da concordare."),
  "service": translate("Grande formato"),
  "sheet": "promo",
  "cell": 2
}, {
  "id": "membership",
  "title": translate("Tessere personalizzate"),
  "category": translate("Azienda"),
  "description": translate("Per soci, clienti o accessi: una tessera riconoscibile, anche con dati e numerazioni variabili."),
  "service": translate("Stampati aziendali"),
  "sheet": "promo",
  "cell": 3
}, {
  "id": "placemats",
  "title": translate("Tovagliette e sottopiatti"),
  "category": translate("Ristorazione"),
  "description": translate("La tavola diventa uno spazio per raccontare il locale, una proposta o un\u2019occasione speciale."),
  "service": translate("Stampati aziendali"),
  "sheet": "promo",
  "cell": 4
}, {
  "id": "menus",
  "title": translate("Men\xF9 e carte dei vini"),
  "category": translate("Ristorazione"),
  "description": translate("Un men\xF9 piacevole da leggere e coerente con il tuo locale, nel formato pi\xF9 adatto."),
  "service": translate("Stampati aziendali"),
  "sheet": "promo",
  "cell": 5
}, {
  "id": "books",
  "title": translate("Libri"),
  "category": translate("Editoria"),
  "description": translate("Dal manoscritto al volume: accompagniamo la scelta di carta, formato e rilegatura."),
  "service": translate("Stampati aziendali"),
  "sheet": "editorial",
  "cell": 0
}, {
  "id": "booklets",
  "title": translate("Opuscoli e libretti"),
  "category": translate("Editoria"),
  "description": translate("Informazioni essenziali in pagine ordinate: per presentazioni, programmi e guide da distribuire."),
  "service": translate("Stampati aziendali"),
  "sheet": "editorial",
  "cell": 2
}, {
  "id": "raffle",
  "title": translate("Biglietti numerati per lotterie"),
  "category": translate("Eventi e regali"),
  "description": translate("Serie numerate, matrici e perforazioni per organizzare la distribuzione dei tuoi biglietti."),
  "service": translate("Soluzioni per aziende"),
  "sheet": "editorial",
  "cell": 3
}, {
  "id": "invoice",
  "title": translate("Fatture e moduli con QR"),
  "category": translate("Azienda"),
  "description": translate("Stampiamo la tua documentazione amministrativa da file, con campi e impaginazione concordati."),
  "service": translate("Stampati aziendali"),
  "sheet": "editorial",
  "cell": 4
}, {
  "id": "sleeves",
  "title": translate("Mappette trasparenti"),
  "category": translate("Azienda"),
  "description": translate("Proteggi e presenta i documenti con mappette personalizzate; materiali e caratteristiche su richiesta."),
  "service": translate("Stampati aziendali"),
  "sheet": "editorial",
  "cell": 5
}, {
  "id": "merch",
  "title": translate("Gadget e abbigliamento"),
  "category": translate("Eventi e regali"),
  "description": translate("Oggetti utili e capi personalizzati per il team, gli eventi e i tuoi clienti."),
  "service": translate("Soluzioni per aziende"),
  "sheet": "display",
  "cell": 0
}, {
  "id": "posters",
  "title": translate("Poster e locandine"),
  "category": translate("Grande formato"),
  "description": translate("Dai spazio al tuo messaggio: immagini, promozioni e appuntamenti in un formato che si nota."),
  "service": translate("Grande formato"),
  "sheet": "display",
  "cell": 1
}, {
  "id": "billboards",
  "title": translate("Manifesti per affissioni"),
  "category": translate("Grande formato"),
  "description": translate("Una campagna pensata per farsi leggere da lontano, nel formato previsto per l\u2019affissione."),
  "service": translate("Grande formato"),
  "sheet": "display",
  "cell": 2
}, {
  "id": "sheetlabels",
  "title": translate("Etichette in foglio"),
  "category": translate("Etichette"),
  "description": translate("Piccole e grandi personalizzazioni per confezioni e comunicazioni, in fogli pratici da utilizzare."),
  "service": translate("Adesivi & etichette"),
  "sheet": "display",
  "cell": 3
}];
